import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { usePaymentMethods } from '../../../hooks/appointments/usePaymentMethods';

export default function PaymentMethodSelect({ onSelect, paymentMethodId, disabledOptions = [] }) {
  const { paymentMethods, loading } = usePaymentMethods();

  const handleChange = (e) => {
    onSelect(e.target.value);
  };

  // Ensure the value is valid: if not found in paymentMethods, fallback to ""
  const validValue = Array.isArray(paymentMethods) && 
  paymentMethods.some(pm => pm.id === paymentMethodId)
    ? paymentMethodId 
    : "";

  return (
    <FormControl fullWidth>
      <InputLabel>Select Payment Method</InputLabel>
      <Select
        value={validValue}
        label="Select Payment Method"
        onChange={handleChange}
        MenuProps={{
          PaperProps: {
            style: { maxHeight: 250 },
          },
        }}
      >

        {/* Render payment methods once loaded */}
        {!loading &&
          paymentMethods?.map((paymentMethod) =>
            !disabledOptions.includes(paymentMethod.id) ? (
              <MenuItem key={paymentMethod.id} value={paymentMethod.id} sx={{ my: 1 }}>
                {paymentMethod.name}
              </MenuItem>
            ) : null
          )}
      </Select>
    </FormControl>
  );
}
